import yesSwipeUrl from '@/assets/images/yes_swipe.svg';
import noSwipeUrl from '@/assets/images/no_swipe.svg';
import skipSwipeUrl from '@/assets/images/skip_swipe.svg';
import { MarketStatus } from '@sportspredict/shared';

export const SWIPE_ONBOARDING_STEPS = [
	{
		key: 'yes',
		title: 'Believe it WILL happen?',
		description: 'Swipe RIGHT if YES.',
		directions: ['right'],
		ctaLabel: 'Next',
	},
	{
		key: 'no',
		title: "Think it WON'T happen?",
		description: 'Swipe LEFT if NO.',
		directions: ['left'],
		ctaLabel: 'Next',
	},
	{
		key: 'skip',
		title: 'Not sure yet?',
		description: 'Swipe UP or DOWN to SKIP. The market stays in the stack so you can decide later.',
		directions: ['up', 'down'],
		ctaLabel: 'Done',
	},
];

export const ONBOARDING_MARKETS = [
	{
		market: {
			id: '878ca1a9-ea51-4da0-9a1d-6cc43ccd837d',
			question: 'Will Team A score at least 1 point?',
			initial_value: 50,
			current_value: 50,
			status: MarketStatus.Open,
			icon: yesSwipeUrl,
		},
		trades: [],
	},
	{
		market: {
			id: 'fe181acb-6d1c-4554-847d-8e790ff1a6fa',
			question: 'Will the match go into triple overtime?',
			initial_value: 50,
			current_value: 50,
			status: MarketStatus.Open,
			icon: noSwipeUrl,
		},
		trades: [],
	},
	{
		market: {
			id: '6e3ec38e-1eb0-4a65-ba6e-f4310d7561f9',
			question: 'Will the Coin Toss be Heads?',
			initial_value: 50,
			current_value: 50,
			status: MarketStatus.Open,
			icon: skipSwipeUrl,
		},
		trades: [],
	},
];

export const SLIDE_ANIMATION_AFTER_TOOGLE_SWIPE_MODE = {
	enter: (direction: number) => ({
		x: direction > 0 ? '100%' : '-100%',
	}),
	center: {
		x: '0%',
		transition: { duration: 0.35, ease: 'easeInOut' },
	},
	exit: (direction: number) => ({
		x: direction > 0 ? '100%' : '-100%',
		transition: { duration: 0.35, ease: 'easeInOut' },
	}),
};

export const SWIPE_ONBOARDING_SEEN_KEY = 'swipe-mode-onboarding-seen';
